import React from 'react';
import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  resolve: () => import(
    /* webpackChunkName: "brand-transition-banners" */
    /* webpackPreload: true */
    './TransitionBanners.js'
  ),
  LoadingComponent: () => <React.Fragment />,
  serverMode: 'defer'
});
